/**
 * As situações da verificação de documento e a definição de "pendência", sem nenhuma chamada de API.
 *
 * Separado de `verificacaoService` de propósito: aquele módulo importa o `api` (axios), e componente
 * que só precisa comparar um status não pode arrastar o cliente HTTP junto — foi o que quebrou o
 * teste do Painel quando estas constantes moravam lá. Aqui elas são importáveis por qualquer tela
 * sem mock nenhum.
 */

/**
 * Prazo anunciado para a análise do documento.
 *
 * Sai de uma constante porque duas telas o prometem — a do funil pós-Pix e a seção do Meu cadastro —
 * e prazo prometido em dois lugares são duas chances de divergirem. O número é o que não pode
 * discordar; cada tela compõe a própria frase em volta dele.
 *
 * Fica fora dos Termos de Uso de propósito: é expectativa operacional, e escrever na peça contratual
 * transformaria um atraso de fim de semana em descumprimento de termo.
 */
export const PRAZO_ANALISE = '24 horas';

/** Espelha br.com.novafaxina.api.model.VerificacaoStatus. */
export const SITUACAO_VERIFICACAO = {
    NAO_ENVIADA: 'NAO_ENVIADA',
    EM_ANALISE:  'EM_ANALISE',
    APROVADA:    'APROVADA',
    REPROVADA:   'REPROVADA',
};

/**
 * Situações em que falta o profissional fazer alguma coisa — a definição de "pendência de
 * verificação" mora aqui para o aviso do dashboard, o destino pós-pagamento e a própria tela nunca
 * discordarem. Mesmo papel do STATUS_COM_PENDENCIA em usePendenciaAssinatura.
 *
 * EM_ANALISE fica de fora de propósito: não há o que fazer enquanto alguém não olhar.
 */
export const SITUACOES_COM_PENDENCIA = [
    SITUACAO_VERIFICACAO.NAO_ENVIADA,
    SITUACAO_VERIFICACAO.REPROVADA,
];

/**
 * true quando falta enviar (ou reenviar) o documento.
 *
 * `situacao` nula é cliente, que não tem perfil profissional — ausência de assunto, não pendência.
 */
export function temPendenciaDeVerificacao(verificacao) {
    return !!verificacao?.situacao && SITUACOES_COM_PENDENCIA.includes(verificacao.situacao);
}
